import { Modal } from 'bootstrap';
import Swiper from 'swiper';
import { Zoom, Keyboard } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/zoom';

// Global image lightbox with pinch-to-zoom (Swiper)
// Usage: window.openLightbox(src, alt)
// Or:   window.dispatchEvent(new CustomEvent('open-lightbox', { detail: { src, alt } }))

(function () {
  let modal = null;
  let swiper = null;

  function buildModal() {
    const el = document.createElement('div');
    el.id = 'image-lightbox-modal';
    el.className = 'modal modal-image-lightbox fade';
    el.tabIndex = -1;
    el.innerHTML = [
      '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Zavřít">',
      '  <i class="icon icon--lg icon-dismiss d-none d-md-block"></i>',
      '  <i class="icon icon-dismiss d-md-none"></i>',
      '</button>',
      '<button type="button" class="btn-scale" aria-label="Přiblížit">',
      '  <i class="icon icon--lg icon-zoom d-none d-md-block"></i>',
      '  <i class="icon icon-zoom d-md-none"></i>',
      '</button>',
      '<div class="modal-dialog modal-dialog-centered modal-xl">',
      '  <div class="modal-content bg-transparent border-0">',
      '    <div class="modal-body p-0">',
      '      <div class="swiper image-lightbox-swiper">',
      '        <div class="swiper-wrapper">',
      '          <div class="swiper-slide">',
      '            <div class="swiper-zoom-container">',
      '              <img class="image-lightbox__img" src="" alt="" />',
      '            </div>',
      '          </div>',
      '        </div>',
      '      </div>',
      '      <p class="image-lightbox__caption text-white text-center mt-2 mb-0 small"></p>',
      '    </div>',
      '  </div>',
      '</div>',
    ].join('\n');
    document.body.appendChild(el);

    modal = new Modal(el, { keyboard: true });

    const scaleBtn = el.querySelector('.btn-scale');

    el.addEventListener('shown.bs.modal', function () {
      if (!swiper) {
        swiper = new Swiper('.image-lightbox-swiper', {
          modules: [Zoom, Keyboard],
          zoom: { maxRatio: 4 },
          keyboard: { enabled: true },
        });
        swiper.on('zoomChange', function () {
          setTimeout(function () {
            swiper.zoom.scale === 1
              ? scaleBtn.classList.remove('active')
              : scaleBtn.classList.add('active');
          }, 100);
        });
      } else {
        swiper.update();
      }
    });

    scaleBtn.addEventListener('click', function () {
      if (swiper) swiper.zoom.toggle();
    });

    el.addEventListener('click', function (e) {
      if (e.target.closest('.swiper-zoom-container') || e.target.closest('.btn-close') || e.target.closest('.btn-scale')) return;
      modal.hide();
    });

    el.addEventListener('hidden.bs.modal', function () {
      if (swiper) swiper.zoom.out();
      scaleBtn.classList.remove('active');
    });

    return el;
  }

  function openLightbox(src, alt, size) {
    let el = document.getElementById('image-lightbox-modal');
    if (!el) el = buildModal();

    el.querySelector('.image-lightbox__img').src = src;
    el.querySelector('.image-lightbox__img').alt = alt || '';
    el.querySelector('.image-lightbox__caption').textContent = alt || '';

    const dialog = el.querySelector('.modal-dialog');
    dialog.className = 'modal-dialog modal-dialog-centered ' + (size || 'modal-xl');

    modal.show();
  }

  window.openLightbox = openLightbox;

  window.addEventListener('open-lightbox', function (e) {
    openLightbox(e.detail.src, e.detail.alt, e.detail.size);
  });

  // Auto-init: click on article images — fullscreen
  document.addEventListener('click', function (e) {
    const img = e.target.closest('.article-content .widget-image-figure__img');
    if (!img) return;
    e.preventDefault();
    openLightbox(img.src, img.alt, 'modal-fullscreen');
  });
})();
